export default __webpack_public_path__ + "static/img/img_5.18bf41e.png";